import React from 'react';

export const WixStyleReactEnvironmentContext = React.createContext({});
